import React from 'react';
import { Link } from 'react-router-dom';
import NotImg from "../../assets/images/404.png"
import { config } from '../pages/config';

const NotFound = () => {
    return (
        <div>
            <div className='row pb-5 justify-content-center'>
                <div className="col-md-7">
                    <Link to={config.appUrl}>
                        <img src={NotImg} alt="" className='w-100' />
                    </Link>

                    <div className='text-center mt-2'>
                        <p className="fs-5 ">Oops! The page you're looking for doesn't exist.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
